module.exports = __webpack_public_path__ + "static/img/medal2.fc41266.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/8/medal2.png
// module id = zqTm
// module chunks = 1